import React, { useState } from "react";
import PropTypes from "prop-types";
import SeeMore from "../SeeMore";
import ExternalLink from "../ExternalLink";
import MediaLink from "../MediaLink";
import { formatDate, parseDate } from "../../../helpers/dates";

const INIT_LIMIT = 5;

function formatDateString(dateString) {
  const date = parseDate(dateString);
  return formatDate(date);
}

const PressList = ({ pressList, parentClassName }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const list = isExpanded ? pressList : pressList.slice(0, INIT_LIMIT);

  return (
    <>
      <ul className={`${parentClassName}__list`}>
        {list.map((press, i) => {
          let formattedDate;
          if (press.date_override) {
            formattedDate = press.date_override;
          } else {
            formattedDate = formatDateString(press.date);
          }
          return (
            <li key={press.id} className={`${parentClassName}__item`}>
              <p className={`${parentClassName}__text`}>
                <strong className={`${parentClassName}__source`}>
                  {press.source}
                </strong>
                {formattedDate && (
                  <span className={`${parentClassName}__date`}>
                    {` | ${formattedDate}`}
                  </span>
                )}
                {press.author && (
                  <span className={`${parentClassName}__author`}>
                    by {press.author}
                  </span>
                )}
              </p>
              {(press.url || press.pdf) && (
                <div className={`${parentClassName}__end`}>
                  {press.url && (
                    <ExternalLink
                      parentClassName={parentClassName}
                      url={press.url}
                    />
                  )}
                  {press.pdf && (
                    <MediaLink
                      parentClassName={parentClassName}
                      path={press.pdf}
                      text="PDF"
                    />
                  )}
                </div>
              )}
            </li>
          );
        })}
      </ul>
      {!isExpanded && pressList.length > INIT_LIMIT && (
        <SeeMore onClick={() => setIsExpanded(true)} />
      )}
    </>
  );
};

PressList.propTypes = {
  pressList: PropTypes.array,
  parentClassName: PropTypes.string.isRequired,
};

export default PressList;
